import { Grid, TextField, Typography } from "@mui/material";
import { Fragment } from "react";
import { format } from "date-fns";
import { statusAgendamento } from "../../Agendamento/AgendamentoContext";

export function DadosImpressao({ printType, pacientes }) {
  if (!printType) return null;

  const toPrint =
    printType === "all"
      ? pacientes.filter(
          (p) =>
            p.status === statusAgendamento.realizado ||
            p.status === statusAgendamento.emAberto
        )
      : pacientes.filter((p) => p.id === printType);

  return (
    <Grid container sx={{ ml: 2 }} className="only-printer">
      {toPrint.map((paciente) => (
        <Fragment key={paciente.id}>
          <Grid item xs={2}>
            <TextField
              label="Pront"
              variant="outlined"
              value={paciente.id}
              fullWidth
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              label="Pront. Físico"
              variant="outlined"
              value={paciente.numeroProntuario || " "}
              fullWidth
            />
          </Grid>
          <Grid item xs={5}>
            <TextField
              label="Nome"
              variant="outlined"
              value={paciente.nome}
              fullWidth
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              label="Nascimento"
              variant="outlined"
              value={
                paciente.nascimento
                  ? format(new Date(paciente.nascimento), "dd/MM/yyyy")
                  : " "
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Typography fontWeight="bold">Evolução</Typography>
            <TextField
              fullWidth
              multiline
              rows={5}
              value={paciente.descricao}
            />
          </Grid>
        </Fragment>
      ))}
    </Grid>
  );
}
